var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeals = function SvgMeals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.065 10.8005V10.1339C1.865 6.73385 4.59834 3.86719 8.065 3.86719C11.465 3.86719 14.1983 6.73385 14.065 10.1339V10.8005M13.1974 12.8008H2.7974C2.53073 12.8008 2.26406 12.5457 2.1974 12.2056L1.66406 10.25H14.3307L13.7974 12.2056C13.7307 12.5457 13.4641 12.8008 13.1974 12.8008ZM7.9974 3.86667C7.26406 3.86667 6.66406 3.26667 6.66406 2.53333V2.33333C6.66406 1.6 7.26406 1 7.9974 1C8.73073 1 9.33073 1.6 9.33073 2.33333V2.53333C9.33073 3.26667 8.73073 3.86667 7.9974 3.86667Z",
    stroke: "#1B382F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMeals;